module.exports = __webpack_public_path__ + "ea27d6d6daef75b8ac60a67152465beb.jpg";